<!--<div class="p-3">-->
<!--  <div class="row">-->
<!--    <div class="col-lg-4" >-->
<!--      <input [(ngModel)]="cerca" placeholder="Cerca" type="text" name="quantita" class="form-control">-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->
<div class="card" >
  <div class="d-md-flex align-items-center bg-white p-2 card-body" >
    <span class="d-flex align-items-center p-2 ">
      <h5 class="mb-0 mr-1 text-dark font-weight-bold font-14"> Contenuti:</h5>
      <span class="badge badge-danger badge-pill px-3 font-weight-bold font-14">{{List?.length ?? 0}}</span>
    </span>
    <div class="ml-auto mt-3 mt-md-0" >
      <button type="button" (click)="Add()" class="btn btn-cyan rounded-pill p-2" ><i
        class="fas fa-plus  font-14 mr-1 text-white"></i>
        <span class="ml-1 text-white font-weight-bold">Aggiungi</span>
      </button>
    </div>
  </div>
</div>
<div class="table-responsive">
  <table class="table bg-white table-hover align-middle " style="margin-bottom: 70px;">
    <thead>
    <tr>
      <th scope="col">Nome</th>
      <th scope="col">Testo</th>
      <th scope="col">Azioni</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let item of List">
      <td class="align-middle">
        <span *ngIf="!item.modifica">{{item.nome}}</span>
        <input [(ngModel)]="item.nome" *ngIf="item.modifica" placeholder="Nome" type="text" class="form-control">
      </td>
      <td class="align-middle">
        <textarea [(ngModel)]="item.testo" *ngIf="item.modifica" placeholder="Testo" type="text" rows="3" name="quantita" class="form-control"></textarea>
      </td>
      <td class="align-middle">
        <a href="javascript:void(0)" class="link font-16 font-medium mr-2" ngbTooltip="{{item?.modifica ? 'Salva' : 'Modifica'}}" [class.text-info]="!item.modifica" [class.text-success]="item.modifica" (click)='Edit(item)'>
          <i class="fas" [class.fa-pencil-alt]="!item.modifica" [class.fa-check]="item.modifica"></i>
        </a>
        <a href="javascript:void(0)" class="link font-16 text-danger font-medium mr-2" (click)='delete(item)'>
          <i class="fas fa-trash-alt"></i>
        </a>
      </td>
    </tr>
    </tbody>
  </table>
</div>
